import { Link } from "react-router-dom";
import { genres } from "@/mocks/genres";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto max-w-page px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-semibold tracking-tight">80s电影</span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200/85">
              一个专注 1980—1989 年经典影片的非商业资料站。我们整理影片资料、撰写影评、记录那个年代的光影与声音。
            </p>
            <p className="mt-5 font-label text-[11px] uppercase tracking-[0.26em] text-accent-300">
              Established 2026 · Archive Project
            </p>
          </div>

          <div>
            <h3 className="font-label text-sm uppercase tracking-[0.18em] text-accent-300">站内导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200/85">
              <li>
                <Link to="/" className="transition-colors hover:text-accent-200">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="transition-colors hover:text-accent-200">
                  电影分类与筛选
                </Link>
              </li>
              <li>
                <Link to="/news" className="transition-colors hover:text-accent-200">
                  影评与影视资讯
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-accent-200">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/search" className="transition-colors hover:text-accent-200">
                  站内搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-label text-sm uppercase tracking-[0.18em] text-accent-300">热门类型</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {genres.slice(0, 6).map((genre) => (
                <Link
                  key={genre.name}
                  to={`/category?genre=${encodeURIComponent(genre.name)}`}
                  className="rounded-full border border-background-100/25 px-3 py-1 text-xs text-background-200/90 transition-colors hover:border-accent-400 hover:text-accent-200"
                >
                  {genre.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-label text-sm uppercase tracking-[0.18em] text-accent-300">联系与说明</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-200/85">
              <li className="flex items-start gap-2.5">
                <i className="ri-mail-line mt-0.5 text-accent-300"></i>
                <a href="mailto:archive@80sfilm.example" className="transition-colors hover:text-accent-200">
                  archive@80sfilm.example
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-time-line mt-0.5 text-accent-300"></i>
                <span>编辑整理：周一至周五 10:00 — 18:00</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-information-line mt-0.5 text-accent-300"></i>
                <span>本站不提供影片在线播放与下载。</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-100/15">
        <div className="mx-auto flex max-w-page flex-col gap-2 px-4 py-5 text-xs text-background-300/80 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© 2026 80s电影 · 本站内容仅用于影迷交流与资料展示，影片版权归原权利人所有。</p>
          <p className="text-background-300/70">演示站点 · 搜索、筛选与收藏均为前端模拟，无后台数据。</p>
        </div>
      </div>
    </footer>
  );
}